export default __webpack_public_path__ + "static/simple-column-3123bbb3413bf7900eb94c24c0620dee.png";